import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { NotificationKind } from '@enmon/commons/lib/enmon';
import type { INotificationsApiClient } from './types/interface';
import type { GetNotificationsArg } from './types/args';
import type { GetNotificationsResult } from './types/results';
import type { Results } from '.';

export class NotificationsApiClient extends BaseApiClient implements INotificationsApiClient {
  constructor() {
    super('api/notifications');
  }

  public get<T extends NotificationKind | null | undefined = NotificationKind>(
    kind: T,
    filter: GetNotificationsArg,
    signal: RequestOptions['signal'],
  ): Promise<GetNotificationsResult<T>> {
    return this.http.get('', { query: getQuery({ ...filter, kind }), signal });
  }

  public getOverview(
    filter: GetNotificationsArg,
    signal: RequestOptions['signal'],
  ): Promise<Results.GetNotificationsOverviewResult> {
    return this.http.get('overview', { query: getQuery(filter), signal });
  }
}
